export default {
  care: {
    hero: {
      eyebrow: 'SSG Care',
      title: 'لكي تعمل تقنية الكاميرات لديك بشكل موثوق على المدى الطويل',
      lead: 'SSG Care هو اشتراك الصيانة والعناية لدينا. بعد التركيب يمكنك إدارة نظامك بعقد Care مرن – برسوم شهرية ومدة متفق عليها فرديًا.',
    },
    abo: {
      title: 'نموذج اشتراك بمدة مرنة',
      lead: 'يُدفع التركيب مرة واحدة. وتتم العناية المستمرة باشتراك شهري – قابل للإلغاء أو بمدة دنيا ثابتة.',
      items: {
        '0': { title: 'عناية شهرية', desc: 'اختر بين إلغاء شهري أو مدة ثابتة (مثل 12 أو 24 شهرًا) بالشروط المناسبة.' },
        '1': { title: 'نطاق خدمات فردي', desc: 'ليس كل نظام يحتاج كل شيء. نحدد معًا الخدمات التي تنتمي إلى عقد Care – قابلة للتوسع والتعديل.' },
        '2': { title: 'لا تكاليف خفية', desc: 'رسوم شهرية شفافة. الخدمات الإضافية خارج العقد تُتفق مسبقًا وتُفوتر منفصلة.' },
      },
    },
    pricing: {
      eyebrow: 'الباقات',
      title: 'اختر باقة Care الخاصة بك',
      lead: 'جميع الأسعار استرشادية. تعتمد الرسوم النهائية على حجم نظامك والنطاق المطلوب والمدة.',
      featured: 'الاختيار الأكثر شيوعًا',
      plans: {
        '0': { name: 'Care Basic', subtitle: 'للأنظمة الصغيرة', price: 'من 19 €/شهر', features: { '0': 'فحص ربع سنوي (عن بُعد)', '1': 'إدارة تحديثات البرامج الثابتة', '2': 'دعم التطبيق هاتفيًا/بالبريد', '3': 'طلبات دعم ذات أولوية' } },
        '1': { name: 'Care Professional', subtitle: 'للأنظمة التجارية', price: 'من 39 €/شهر', features: { '0': 'فحص شهري (عن بُعد)', '1': 'تحديثات البرامج الثابتة وتصحيحات الأمان', '2': 'إدارة المستخدمين والحقوق', '3': 'مراقبة التخزين والتسجيل', '4': 'مساعدة عند تغيير الهاتف', '5': 'خدمة في الموقع حسب الاتفاق', '6': 'معالجة ذات أولوية' } },
        '2': { name: 'Care Enterprise', subtitle: 'للمواقع المتعددة والمشاريع الكبيرة', price: 'فردي', features: { '0': 'فحص أسبوعي (عن بُعد)', '1': 'جميع خدمات Professional', '2': 'جهة اتصال مخصصة', '3': 'نصائح توسعة استباقية', '4': 'مواعيد منتظمة في الموقع', '5': 'توثيق وتقارير' } },
      },
    },
    services: {
      title: 'ما يمكن أن يفعله SSG Care لك',
      items: {
        '0': { title: 'فحوصات دورية', desc: 'فحص وظيفة الكاميرا والتسجيل واتصال الشبكة – عن بُعد أو في الموقع حسب الباقة.' },
        '1': { title: 'تحديثات البرامج الثابتة', desc: 'فحص وتنفيذ التحديثات المتفق عليها وفقًا للمصنّع.' },
        '2': { title: 'دعم التطبيق والوصول', desc: 'مساعدة في مشاكل التطبيق والوصول وتغيير الهاتف أو إعادة التثبيت.' },
        '3': { title: 'إدارة المستخدمين والحقوق', desc: 'إدارة حقوق الوصول والمستخدمين الجدد وتغييرات الصلاحيات.' },
        '4': { title: 'التسجيل والتخزين', desc: 'فحص إشغال التخزين وجودة التسجيل وحالة النسخ الاحتياطي.' },
        '5': { title: 'دعم عن بُعد', desc: 'وصول عن بُعد للتشخيص والإعداد، إذا كان ممكنًا تقنيًا ومرغوبًا منك.' },
      },
    },
    form: {
      title: 'عرض Care الشخصي الخاص بك',
      lead: 'أخبرنا بالعناية التي تتخيلها. سنرد عليك باقتراح فردي يشمل المدة والرسوم الشهرية.',
      customerType: 'نوع العميل',
      select: 'الرجاء الاختيار',
      privat: 'خاص',
      gewerbe: 'شركة',
      locations: 'عدد المواقع',
      locations1: 'موقع واحد',
      locations2: '2–3 مواقع',
      locations3: '4 وأكثر',
      cameraCount: 'العدد التقريبي للكاميرات',
      cameras1: '1–2 كاميرات',
      cameras2: '3–6 كاميرات',
      cameras3: '7–12 كاميرا',
      cameras4: '13 وأكثر',
      systemStatus: 'حالة النظام',
      statusNew: 'نظام جديد',
      statusExisting: 'نظام قائم',
      statusExtension: 'توسعة مخططة',
      contractTerm: 'مدة العقد المطلوبة',
      termOpen: 'مفتوح / حسب الاتفاق',
      termMonthly: 'إلغاء شهري',
      term12: '12 شهرًا',
      term24: '24 شهرًا',
      term36: '36 شهرًا',
      name: 'الاسم *',
      email: 'البريد الإلكتروني *',
      phone: 'الهاتف',
      company: 'الشركة',
      message: 'معلومات إضافية',
      maxChars: 'حد أقصى 500 حرف',
      consent: 'قرأت سياسة الخصوصية وأوافق على معالجة بياناتي لمعالجة هذا الطلب. *',
      success: 'شكرًا لطلبك. سنرد عليك قريبًا بعرض Care الفردي الخاص بك.',
      submit: 'إرسال طلب Care',
      submitting: 'جارٍ الإرسال...',
    },
  },
};